import React from 'react';
import styled from 'styled-components';

const Row = styled.div`
  display: flex;
  align-items: center;
  margin: 10px 0;
`;

const Left = styled.div`
  display: flex;
  align-items: baseline;
  width: 180px;
  gap: 10px;
`;

const Count = styled.span`
  font-weight: 700;
  color: ${props => props.color};
  width: 28px;
  display: inline-block;
  text-align: right;
`;

const Label = styled.span`
  font-weight: 700;
  text-transform: uppercase;
  color: ${props => props.color};
`;

const BarWrap = styled.div`
  flex: 1;
  background: #e6f0ff00;
`;

const Bar = styled.div`
  height: 18px;
  border-radius: 2px;
  width: ${p => Math.max(0, Math.min(100, p.width))}%;
  background: ${p => p.color};
`;

const palette = {
  FAST: '#5B8FF9',
  NORMAL: '#36C361',
  SLOW: '#FAAD14',
  'NOT MEASURED': '#BFBFBF',
};

const WorkSegmentsBySpeedChart = ({ data = [] }) => {
  const max = Math.max(1, ...data.map(d => d.value || 0));
  const rows = data.map(d => ({
    ...d,
    width: (d.value / max) * 100,
    color: palette[d.type] || '#5B8FF9',
  }));

  return (
    <div>
      {rows.map(row => (
        <Row key={row.type}>
          <Left>
            <Count color={row.color}>{row.value}</Count>
            <Label color={row.color}>{row.type}</Label>
          </Left>
          <BarWrap>
            <Bar width={row.width} color={row.color} />
          </BarWrap>
        </Row>
      ))}
    </div>
  );
};

export default WorkSegmentsBySpeedChart; 